import React from 'react';
import { toaster } from 'rsuite';
import ToastContent from './ToastContent';
import styles from './Toast.module.scss';

export interface IShowToastOptions {
  title: string;
  body?: string;
  duration?: number;
  type?: 'success' | 'error';
}

/** Default time on screen before auto-dismiss. Pass `duration: 0` to keep open. */
export const TOAST_DEFAULT_DURATION_MS = 4000;

/**
 * TXT-styled toast (top-right). Pushes ToastContent straight into the RSuite
 * toaster so there is a single card with its own close button.
 * Auto-dismisses after `duration` ms (default 4s); hover pauses the timer.
 */
export function showToast({
  title,
  body,
  duration = TOAST_DEFAULT_DURATION_MS,
  type = 'success',
}: IShowToastOptions): void {
  toaster.push(
    React.createElement(ToastContent, {
      title,
      body,
      // Pass duration on the element too — RSuite injects it from push options,
      // but custom content must own the close timer (Notification does this
      // internally; ToastContent does not).
      duration,
      iconName: type === 'error' ? 'alert-circle' : 'check-circle',
      iconClassName:
        type === 'error' ? styles.dangerIcon : styles.successIcon,
    }),
    { placement: 'topEnd', duration },
  );
}

export default showToast;
